import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Select } from "chakra-react-select";

interface AddCompany {
  selectedCompany: string;
  setSelectedCompany: (value: string) => void;
  customTitle?: string;
}

const AddCompany = (props: AddCompany) => {
  const { selectedCompany, setSelectedCompany } = props;

  const { t } = useTranslation("translations");

  const [formattedList, setFormattedList] = useState<{ value: string; label: string; colorScheme: string }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetch = async () => {
    setIsLoading(true);
    try {
        const res = await getAxiosInstance().get(`/Companies`);
        setFormattedList(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "yellow"})))
    } catch (e) {
        console.log(e);
    } finally {
        setIsLoading(false);
    }
  }

  useEffect(() => {
    fetch();
  }, []);

  return (
    <FormControl>
      <FormLabel>{props.customTitle ?? t("SELECT_COMPANY")}</FormLabel>
      <Select
        isRequired
        name={t("SELECT_COMPANY")}
        options={formattedList}
        value={formattedList.findIndex(x => x.value === selectedCompany) != -1 ? formattedList[formattedList.findIndex(x => x.value === selectedCompany)] : null}
        tagVariant="solid"
        placeholder={t("SELECT_COMPANY_PLACEHOLDER")}
        onChange={(e) => {
          if(e) setSelectedCompany(e.value);
        }}
        isLoading={isLoading}
      />
    </FormControl>
  );
};

export default AddCompany;
